import { ErrorHandler } from '@src/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * MenuItem
 *
 * Renders an icon and title for usage in a navigation component.
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function MenuItem(props) {
  const { iconName, title } = props;

  return (
    <ErrorHandler location="src/layouts/default/Header/components/Navigation/components/MenuItem/MenuItem.jsx">
      <div className="nav-icon-wrap">
        <IconSymbol icon={iconName} />
        <Text>{title}</Text>
      </div>
    </ErrorHandler>
  );
}

MenuItem.propTypes = {
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
